module.exports = __webpack_public_path__ + "static/img/kuo.56caafb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kuo.jpg
// module id = SqCj
// module chunks = 5